import React from 'react';
interface TestimonialCardProps {
  initials: string;
  stars: number;
  quote: string;
  name: string;
  location: string;
  level: string;
}
function TestimonialCard({
  initials,
  stars,
  quote,
  name,
  location,
  level
}: TestimonialCardProps) {
  return <div className="bg-black border border-[#00B4D8]/30 rounded-2xl p-6 flex flex-col gap-4" data-id="element-364">
      <div className="flex items-center gap-3" data-id="element-365">
        <div className="w-12 h-12 rounded-full bg-[#00B4D8]/20 border border-[#00B4D8]/40 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-366">
          {initials}
        </div>
        <div data-id="element-367">
          <div className="text-[#00B4D8] text-sm" data-id="element-368">{'⭐'.repeat(stars)}</div>
          <div className="text-white font-bold text-sm" data-id="element-369">{name}</div>
          <div className="text-gray-400 text-xs" data-id="element-370">
            📍 {location} | {level}
          </div>
        </div>
      </div>
      <p className="text-gray-300 text-sm leading-relaxed italic" data-id="element-371">"{quote}"</p>
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-372">
      <div className="max-w-5xl mx-auto" data-id="element-373">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-4" data-id="element-374">
          Lo que dicen los docentes de Francés
          <br data-id="element-375" />
          <span className="text-[#00B4D8]" data-id="element-376">que ya tienen su MegaPack:</span>
        </h2>
        <p className="text-gray-400 text-center mb-10" data-id="element-377">
          +500 docentes de Argentina ya lo usan
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-378">
          <TestimonialCard initials="MG" stars={5} quote="Compré el MegaPack un domingo a la noche. El lunes tenía todo el año de Francés organizado. Nunca pensé que un material iba a ser tan completo. Las secuencias didácticas son exactamente lo que necesitaba: no tengo que pensar de cero para cada clase. Y el solucionario es un lujo — corrijo evaluaciones en minutos, no en horas. Mis alumnos por fin entienden para qué sirve el francés." name="Mariela G." location="Córdoba" level="Docente de Francés Secundaria" data-id="element-379" />
          <TestimonialCard initials="CR" stars={5} quote="El Sistema de 3 Capas me salvó la vida. Ya no armo dos materiales distintos para cada clase." name="Cecilia R." location="Mendoza" level="Docente de Francés + Instituto" data-id="element-380" />
          <TestimonialCard initials="RM" stars={5} quote="Con el activador 'Speed Dating Linguistique' el grupo entero estaba hablando en francés en 10 minutos." name="Roberto M." location="Buenos Aires" level="Docente de Francés" data-id="element-381" />
          <TestimonialCard initials="VT" stars={5} quote="El Bono 'Kit Domingo Cero' me cambió la vida. La semana cerrada en 12 minutos." name="Valeria T." location="Santa Fe" level="Docente de Francés" data-id="element-382" />
          <TestimonialCard initials="MD" stars={5} quote="Dudé por el precio cinco minutos. Recuperé esa inversión en la primera semana que no perdí el domingo armando material." name="Martín D." location="Rosario" level="Docente de Francés" data-id="element-383" />
        </div>
      </div>
    </section>;
}